import { Base } from '@studiometa/js-toolkit';

/**
 * AddCrossSell component
 */
export default class AddCrossSell extends Base {
  /**
   * Component Configuration
   */
  static config = {
    name: 'AddCrossSell',
    options: {
      productid: {
        type: String,
      },
    },
    emits: ['add-to-cart'],
  };

  /**
   * on element click
   */
  onClick() {
    this.$root.addToCart(this.$options.productid);
  }
}
